import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Alert, Button, Chip, CircularProgress, Stack, Typography } from "@mui/material";
import VerifiedRounded from "@mui/icons-material/VerifiedRounded";
import {
  confirmAccountVerification,
  refreshAccountVerification,
  redirectToDefaultEmailAction,
} from "services/firebase";
import VerificationFrame, { verificationError } from "components/EmailVerification/Frame";
export default function VerifyAccount({ user }) {
  const [params] = useSearchParams();
  const code = params.get("oobCode"),
    mode = params.get("mode");
  const query = params.toString();
  const [state, setState] = useState({ status: "loading" });
  useEffect(() => {
    let active = true;
    setState({ status: "loading" });
    (async () => {
      try {
        if (code) {
          if (mode && mode !== "verifyEmail") {
            redirectToDefaultEmailAction(query);
            if (active) setState({ status: "redirecting" });
            return;
          }
          if (!mode) throw new Error("Este link de confirmação está incompleto.");
          const email = await confirmAccountVerification(code);
          if (active) setState({ status: "verified", email });
        } else {
          const verified = await refreshAccountVerification();
          if (active) setState({ status: verified ? "verified" : "pending" });
        }
      } catch (failure) {
        if (active) setState({ status: "error", message: verificationError(failure) });
      }
    })();
    return () => {
      active = false;
    };
  }, [code, mode, query]);
  return (
    <VerificationFrame>
      <Stack spacing={2.5}>
        {state.status === "loading" || state.status === "redirecting" ? (
          <Stack role="status" alignItems="center" spacing={2}>
            <CircularProgress sx={{ color: "#147d48" }} />
            <Typography>
              {state.status === "redirecting"
                ? "Abrindo a confirmação segura do Firebase…"
                : "Verificando sua conta…"}
            </Typography>
          </Stack>
        ) : state.status === "verified" ? (
          <>
            <VerifiedRounded sx={{ color: "#147d48", fontSize: 46 }} />
            <Chip label="Verificado" color="success" sx={{ alignSelf: "flex-start" }} />
            <Typography variant="h4" sx={{ color: "#182d27", fontSize: 28 }}>
              E-mail confirmado
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Sua conta{state.email ? ` (${state.email})` : ""} foi verificada. Continue para
              conferir as permissões e os termos de uso.
            </Typography>
            <Button
              component={Link}
              to={user ? "/dashboard" : "/login"}
              variant="contained"
              color="success"
            >
              {user ? "Continuar para a plataforma" : "Entrar na minha conta"}
            </Button>
          </>
        ) : (
          <>
            <Typography variant="h5">
              {state.status === "error" ? "Não foi possível confirmar" : "Verificação pendente"}
            </Typography>
            <Alert severity={state.status === "error" ? "error" : "info"}>
              {state.message ||
                "Abra o link enviado ao seu e-mail. Você pode solicitar outro e-mail na tela da sua conta."}
            </Alert>
            <Button
              component={Link}
              to={user ? "/dashboard" : "/login"}
              variant="contained"
              color="success"
            >
              {user ? "Voltar à minha conta" : "Entrar na minha conta"}
            </Button>
          </>
        )}
      </Stack>
    </VerificationFrame>
  );
}
